import React from "react";
import Chip from "../Chip";
import MUIGreyColor from "@mui/material/colors/grey";
import MUIAvatar from "@mui/material/Avatar";
import InsuranceType from "../../Utility/Crud/InsuranceType";

export default class ChipInsuranceType extends Chip {
    /**
     * Renders a MUI Avatar.
     */
    renderAvatar() {
        const color = (this.props.insuranceType ? InsuranceType.getColor() : MUIGreyColor[500]);
        const avatarColor = this.props.isTransparent ? "transparent" : color;
        const iconColor = this.props.isTransparent ? color : "#fff";

        return (
            <MUIAvatar sx={{ bgcolor: avatarColor }}>
                {InsuranceType.getIcon({ fontSize: "small", sx: { color: iconColor } })}
            </MUIAvatar>
        );
    }

    /**
     * @return {string} The insuranceType name.
     */
    getLabel() {
        return this.props.insuranceType ? InsuranceType.getDisplayName(this.props.insuranceType) : "None";
    }
}
